import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Graphic from "@arcgis/core/Graphic";
import RouteParameters from "@arcgis/core/rest/support/RouteParameters.js";
import FeatureSet from "@arcgis/core/rest/support/FeatureSet.js";
import * as route from "@arcgis/core/rest/route.js";
import { routeParamsApiKey } from "../../../configs/arcgisServices";

// Route layer
export const routeLayer = new GraphicsLayer();

// Route parameters
export const routeParams: any = new RouteParameters({
  apiKey: routeParamsApiKey,
  stops: new FeatureSet(),
  outSpatialReference: {
    wkid: 3857,
  },
});

// Symbol definitions for routing
export const ROUTE_SYMBOLS = {
  start: {
    type: "text",
    color: "red",
    haloColor: "#4f2cdb",
    haloSize: "1px",
    text: "A",
    xoffset: 3,
    yoffset: 3,
    font: {
      size: 20,
      family: "Arial",
      weight: "bold",
    },
  },
  stop: {
    type: "text",
    color: "red",
    haloColor: "#4f2cdb",
    haloSize: "1px",
    text: "B",
    xoffset: 3,
    yoffset: 3,
    font: {
      size: 20,
      family: "Arial",
      weight: "bold",
    },
  },
  route: {
    type: "simple-line",
    color: [0, 0, 255, 0.5],
    width: 7,
  },
} as const;

// Legacy symbol variables (maintained for compatibility)
export const stopTextSymbol = ROUTE_SYMBOLS.stop;
export const startTextSymbol = ROUTE_SYMBOLS.start;
export const routeSymbol = ROUTE_SYMBOLS.route;

// Route URL
export const routeUrl = "https://route-api.arcgis.com/arcgis/rest/services/World/Route/NAServer/Route_World";

/**
 * Adds a stop to the route
 */
export const addStop = async (event: any, mapViewData?: any) => {
  console.log("event==>", event);

  // Add a point at the location of the map click
  const stop = new Graphic({
    geometry: event.mapPoint != null ? event.mapPoint : event.geometry,
    symbol: event.mapPoint != null ? stopTextSymbol : startTextSymbol,
  });

  routeLayer.add(stop);

  // Execute the route if 2 or more stops are input
  routeParams.stops.features.push(stop);
  if (routeParams.stops.features.length >= 2) {
    route.solve(routeUrl, routeParams).then((data) => showRoute(data, mapViewData));
  } else {
    console.log("try to get currentLocation");
    // Note: Geolocation logic should be handled by the calling component
    // This function should return a promise or use a callback
  }
};

/**
 * Shows the solved route on the map
 */
export const showRoute = (data: any, mapViewData?: any) => {
  console.log("showRoute==>data", data);

  let total_Kilometers = data.routeResults[0].route.attributes.Total_Kilometers;
  let stopCount = data.routeResults[0].route.attributes.StopCount;
  let total_TravelTime = data.routeResults[0].route.attributes.Total_TravelTime;
  
  console.log("showRoute==>total_Kilometers", total_Kilometers);
  console.log("showRoute==>stopCount", stopCount);
  console.log("showRoute==>total_TravelTime", total_TravelTime);

  const routeResult = data.routeResults[0].route;
  routeResult.symbol = routeSymbol;
  routeLayer.add(routeResult);
  
  // Only call goTo if MapViewData is provided
  if (mapViewData && mapViewData.goTo) {
    mapViewData.goTo(routeResult);
  }

  // Return route data for the calling component to handle
  return {
    routeResult: routeResult,
    total_Kilometers,
    stopCount,
    total_TravelTime
  };
};

/**
 * Clears the route layer
 */
export const clearRoute = () => {
  routeLayer.removeAll();
  routeParams.stops.features = [];
};

/**
 * Gets route layer
 */
export const getRouteLayer = () => routeLayer;

/**
 * Gets route parameters
 */
export const getRouteParams = () => routeParams;
